import { Injectable, ElementRef } from '@angular/core';
import { ICONS } from '@eda/core/icons/icons.constants.js';

@Injectable({
  providedIn: 'root',
})
export class IconsService {

  getIcon(icon: string, iconContainer: ElementRef | HTMLElement) {
    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(ICONS[icon as keyof typeof ICONS]?.svgContent, 'image/svg+xml');
    const svgElement = svgDoc.documentElement as HTMLElement;
    const containerElement = (iconContainer as ElementRef).nativeElement || iconContainer;

    containerElement.appendChild(svgElement);
  }
}
